import React from 'react';
import styled from '../../../../styled';
import { ColumnButton } from './Column';
import { getYearRageStart, TODAY } from '../day';
const Container = styled.div `
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;
const YearColumn = styled(ColumnButton) `
  width: 4.5625rem;
  height: 1.75rem;
  margin: 0.5rem 0;
`;
const YearCalendarView = ({ target, selectedDate, selectedFrom, selectedTo, onSelect, disabledDate, }) => {
    const years = new Array(10)
        .fill(null)
        .map((_, i) => getYearRageStart(target.year()) + i);
    return (React.createElement(Container, null, years.map((year) => {
        const targetYear = target.year(year);
        const isThisYear = targetYear.isSame(TODAY, 'year');
        const from = selectedFrom || selectedDate;
        const to = selectedTo || selectedDate;
        const isPeriod = from &&
            to &&
            targetYear.isBetween(from, to, 'year', '[]');
        const isSelected = !!selectedDate && targetYear.isSame(selectedDate, 'year');
        const isFromSelected = from && targetYear.isSame(from, 'year');
        const isToSelected = to && targetYear.isSame(to, 'year');
        const isDisabled = disabledDate === null || disabledDate === void 0 ? void 0 : disabledDate(targetYear.toDate());
        return (React.createElement(YearColumn, { key: targetYear.toString(), isDefault: isThisYear, isSelected: isSelected, isFromSelected: isFromSelected, isToSelected: isToSelected, isPeriod: isPeriod, onClick: () => !isDisabled && onSelect(year), isDisabled: isDisabled }, year.toString()));
    })));
};
export default YearCalendarView;
//# sourceMappingURL=YearCalendarView.js.map